import { default as AbstractForm } from './_AbstractForm'
import { VInputText, VInputSelect, VFormSubmission } from '../vue/components'
import { email, required } from '@vuelidate/validators'
import { API_ENDPOINTS } from '../config'

export default class extends AbstractForm {
    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el

        // Abstract vars
        this.components = {
            VInputText,
            VInputSelect,
            VFormSubmission,
        }
        this.rules = {
            firstname: { required },
            lastname: { required },
            email: { email, required },
            topic: {},
            message: { required },
        }
        this.endpoint = API_ENDPOINTS.FORM_CONTACT
        this.submission = {
            success: `
                Thank you for contacting us. <br>
                We'll get back to you shortly.
            `
        }
    }
}
